import ExtendableError from 'es6-error';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import set from 'lodash/set';

export class SubmissionError extends ExtendableError {
  constructor(errors) {
    super('Submit Validation Failed');
    this.errors = errors;
  }
}

export const formatErrorsForFormik = (errors) =>
  errors.reduce((errorObject, error) => {
    const fieldName = get(error, 'meta.field', '').split('.').pop();

    if (fieldName) {
      // eslint-disable-next-line no-param-reassign
      errorObject[fieldName] = get(error, 'detail');
    }

    return errorObject;
  }, {});

export const submitErrors = (errors) => {
  if (!errors) return;
  const formikErrors = formatErrorsForFormik(errors);

  if (!isEmpty(formikErrors)) {
    throw new SubmissionError(formikErrors);
  }
};

export const showErrors = (errors, all = false) => {
  const { response: { data: { errors: adminAPIErrors = [] } = {} } = {} } = errors;
  if (adminAPIErrors.length) {
    if (!all) {
      const nonFieldErrors = adminAPIErrors.filter((error) => {
        const { meta: { field } = {} } = error;
        return !field;
      });
      if (nonFieldErrors.length) {
        window.flashNotifier(
          'warning',
          nonFieldErrors.map((error) => error.detail).join('<br>'),
          15
        );
      }
    } else {
      window.flashNotifier('warning', adminAPIErrors.map((error) => error.detail).join('<br>'), 15);
    }
  }
};

export const showLegacyApiErrors = (errors) => {
  const { response: { data: { message = '' } = {} } = {} } = errors;
  if (message) {
    window.flashNotifier('warning', message, 15);
  }
};

export const createErrorMapFunction = (errorMap) => (errors) => {
  if (!errors) return {};

  return errors.reduce((errorObject, backendError) => {
    const backendFieldName = get(backendError, 'meta.field');
    const fieldName = errorMap[backendFieldName];

    if (fieldName) {
      return set(errorObject, fieldName, get(backendError, 'detail', ''));
    }

    return errorObject;
  }, {});
};
